import { useAuth } from "@/hooks/useAuth";
import { Outlet } from "react-router-dom";
import LoginForm from "./LoginForm";

function ProtectedRoute() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Outlet />;
  }

  return (
    <LoginForm />
  );
}

export default ProtectedRoute;
